import { CaseDetailCard } from './CaseDetailCard';

export * from './CaseDetailCard.types';
export { CaseDetailCard };

export default CaseDetailCard;
